import { render, staticRenderFns } from "./TkBadge.vue?vue&type=template&id=7137848d&scoped=true&"
import script from "./TkBadge.vue?vue&type=script&lang=js&"
export * from "./TkBadge.vue?vue&type=script&lang=js&"
import style0 from "./TkBadge.vue?vue&type=style&index=0&id=7137848d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137848d",
  null
  
)

export default component.exports